<template>
  <v-data-table
    :headers="headers"
    :items="patients"
    :loading="loading"
    :options.sync="options"
    :server-items-length="totalHits"
    :footer-props="{
      itemsPerPageOptions: [50, 100, 150]
    }"
    class="show-hover outlined"
    @update:options="pagination"
  >
    <template #item="props">
      <tr
        :key="props.id"
        :data-e2e-id="`patient-${props.item.externalId}`"
        @click="clickPatient(props.item.id)"
      >
        <td class="text-truncate" style="max-width: 20vw">
          <app-tooltip top>
            <template #activator="{ on }">
              <span v-on="on">
                <a v-if="useReactPatientDetailsLink" :href="createReactPatientLink(props.item.id)">
                  {{ props.item.externalId }}
                </a>
                <router-link v-else :to="createDemographicsRoute(props.item.id)" class="viper-link">
                  {{ props.item.externalId }}
                </router-link>
              </span>
            </template>
            <div>{{ props.item.externalId }}</div>
          </app-tooltip>
        </td>
        <td class="text-truncate" style="max-width: 20vw">
          <app-tooltip top>
            <template #activator="{ on }">
              <span v-on="on">
                {{ props.item.sortableName | orDefault }}
              </span>
            </template>
            <div>{{ props.item.sortableName | orDefault }}</div>
          </app-tooltip>
        </td>
        <td>
          {{ parseDate(props.item.demographics.dateOfBirth) | dateFormat('utc') | orDefault }}
        </td>
        <td class="text-truncate" style="max-width: 80px">
          <app-tooltip top>
            <template #activator="{ on }">
              <span v-on="on">
                {{ props.item.demographics.genderName | orDefault }}
              </span>
            </template>
            <div>{{ props.item.demographics.genderName | orDefault }}</div>
          </app-tooltip>
        </td>
        <td>
          {{ new Date(props.item.lastUpdated) | dateFormat('ll') }}
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { MyActiveOrganization } from '@/helpers/my-account-helper'
import _ from 'lodash'
import moment from 'moment'
import { isFeatureOn } from '@/helpers/feature-flag-helper'

export default {
  props: {
    results: { type: Object, default: () => {} },
    loading: { type: Boolean, default: () => false },
    pageNumber: { type: Number, default: () => 1 },
    itemsPerPage: { type: Number, default: () => 50 },
    sortField: { type: String, default: 'lastUpdated' },
    sortDirection: { type: String, default: 'desc' }
  },
  data() {
    return {
      headers: [
        {
          text: 'Patient ID',
          align: '',
          sortable: false,
          value: 'externalId',
          width: ''
        },
        {
          text: 'Name',
          align: '',
          sortable: true,
          value: 'sortableName',
          width: ''
        },
        {
          text: 'DOB',
          align: '',
          sortable: true,
          value: 'demographics.dateOfBirth',
          width: ''
        },
        {
          text: 'Sex',
          align: '',
          sortable: false,
          value: '',
          width: ''
        },
        {
          text: 'Last Updated',
          align: '',
          sortable: true,
          value: 'lastUpdated',
          width: ''
        }
      ],
      options: {
        itemsPerPage: this.itemsPerPage,
        sortDesc: [this.sortDirection === 'desc'],
        sortBy: [this.sortField],
        page: this.pageNumber
      }
    }
  },
  computed: {
    orgId() {
      return MyActiveOrganization.id
    },
    patients() {
      return _.get(this.results, 'patients', [])
    },
    totalHits() {
      return _.get(this.results, 'totalHits', 10)
    },
    useReactPatientDetailsLink() {
      return isFeatureOn('viper-platform-ui-react-patient-details-page')
    }
  },
  methods: {
    createDemographicsRoute(patientId) {
      return {
        name: 'patient-demographics',
        params: { orgId: this.orgId, patientId: patientId }
      }
    },
    createReactPatientLink(patientId) {
      return `${window.$appConfig.VUE_APP_PLATFORM_UI_URL}/org/${this.orgId}/patient-details/${patientId}`
    },
    clickPatient(patientId) {
      if (this.useReactPatientDetailsLink)
        window.location.href = this.createReactPatientLink(patientId)
      else this.$router.push(this.createDemographicsRoute(patientId))
    },
    pagination() {
      this.$emit('pagination', this.options)
    },
    parseDate(ms) {
      if (_.isNil(ms)) return null
      return moment.utc(ms)
    }
  }
}
</script>

<style lang="scss" scoped>
/* stylelint-disable-next-line selector-pseudo-element-no-unknown */
::v-deep .v-data-table tbody tr {
  cursor: pointer;
}
</style>
